<template>
 
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
export default {
};
</script>

<style></style>
